import { useCallback } from 'react';
import type { KeyboardEvent } from 'react';

export function useKeyboardCarouselNavigation<T extends HTMLElement>() {
  return useCallback(
    (
      e: KeyboardEvent<T>,
      index: number,
      refs: Array<T | null>,
      onSelect: (_i: number) => void,
    ) => {
      const key = e.key;
      const total = refs.length;

      const isNavKey = [
        'ArrowRight',
        'ArrowDown',
        'ArrowLeft',
        'ArrowUp',
      ].includes(key);
      const isActionKey = key === 'Enter' || key === ' ';

      if (isNavKey || isActionKey) {
        e.preventDefault();
      }

      let nextIndex = index;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        nextIndex = (index + 1) % total;
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        nextIndex = (index - 1 + total) % total;
      }

      if (isNavKey) {
        const nextEl = refs[nextIndex];
        if (nextEl) {
          // translatorPrevents sudden jump
          nextEl.focus({ preventScroll: true });
          //  manual scroll if you want (optional)
          nextEl.scrollIntoView({
            inline: 'nearest',
            block: 'nearest',
            behavior: 'smooth',
          });
        }
      } else if (isActionKey) {
        onSelect(index);
      }
    },
    [],
  );
}
